// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"74b8fb27","173":"f11ed88c","424":"57e5e92f","464":"41fc5bed","487":"42d2e395","689":"01226e99","906":"106b7918","969":"028f8947","978":"cd270d7e"}[chunkId] + ".chunk.css";
};